import * as React from 'react';

export interface UpdateProps {
    setUpdateFunc;
}
/**
 * Gets a `setUpdateFunc` function in the props and sends it the `update` method's reference.
 * When `update` function is called ( somewhere in the caller's code ) the components rerenders = gets updated!
 * @param Component
 */
export const withUpdate = <P extends UpdateProps>(Component: React.ComponentType<P>) => {
    return class extends React.Component<P, any> {
        constructor(props) {
            super(props);

            const {setUpdateFunc} = this.props;
            if (setUpdateFunc) setUpdateFunc(this.update);

            this.state = {isUpdate: false};
        }

        update = () => {
            this.setState({isUpdate: !this.state.isUpdate});
        };

        render() {
            return <Component {...this.props} />;
        }
    };
};
